import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import Icons from "../../assets/icons/index";
import Images from "../../assets/images/index";
import { CreateOrder, getCountryStateCityData, getCountryStateCityList, getOrder, preShopSubmitPackage, shopcoupon, shopPackageDetail, ShopSubmitPackage } from "../../restApi/api";
import { decrypt } from "../../utils/crypto";
import { toast, ToastContainer } from 'react-toastify';
import Modal from "react-bootstrap/Modal";
import Toggle from "react-toggle"
import { authorizationCheck } from "../../utils/logout";
import { Package_detail_Api } from "../../gql/queries";
import { useQuery } from "@apollo/client";
import SomethingWentWrong from "../common/NoDataFound/SomethingWentWrong";
import Loader from "../common/Loader/Loader";
import ConnectionError from "../common/NoDataFound/ConnectionError";


const INITIAL_STATE = {
    colonyArea: '',
    city: '',
    country: '',
    flateNumber: '',
    landmark: '',
    pincode: '',
    state: '',
    shippingcolonyArea: '',
    shippingcity: '',
    shippingcountry: '',
    shippingflateNumber: '',
    shippinglandmark: '',
    shippingpincode: '',
    shippingstate: '',
};
export default function PlanAddons() {

    function loadScript(src) {
        return new Promise((resolve) => {
            const script = document.createElement("script");
            script.src = src;
            script.onload = () => {
                resolve(true);
            };
            script.onerror = () => {
                resolve(false);
            };
            document.body.appendChild(script);
        });
    }

    let { id } = useParams()
    let location = useLocation();
    const [shop, setShop] = useState([])
    const [type, setType] = useState(location.state)
    const [orderShow, setOrder] = useState(false);
    const orderInfo = () => setOrder(true);
    const orderHide = () => setOrder(false);
    const [courseShowData, setcourseShow] = useState(false);
    const courseInfo = () => setcourseShow(true);
    const courseHide = () => setcourseShow(false);
    const [preSubscription, setPreSubscription] = useState();
    let [AddonpaymentDetail, setAddonpaymentDetail] = useState({});
    const [country, setCountry] = useState(null);
    const [packages, setPackage] = useState(true);
    const [validity, setValidity] = useState({});
    const [coupon, setCoupon] = useState('');
    const [state, setState] = useState(null);
    const [city, setCity] = useState(null);
    let [index, setIndex] = useState(0);
    const [course, setCourse] = useState(JSON.parse(decrypt(localStorage.getItem('profileDetails'))));
    const [getProfileDetails, profileDetails] = useState(INITIAL_STATE);
    const [countryId, setcountryId] = useState(null);
    const [stateId, setStateId] = useState(null);
    const [cityId, setCityId] = useState(null);
    const [shipcountryId, setshipcountryId] = useState(null);
    const [shipstateId, setshipStateId] = useState(null);
    const [shipcityId, setshipCityId] = useState(null);
    const [shipstate, setshipState] = useState(null);
    const [shipcountry, setshipCountry] = useState(null);
    const [shipcity, setshipCity] = useState(null);
    // const [shop, setShop] = useState([]);
    const navigate = useNavigate();
    const [totalAmountAddon, settotalAmountAddon] = useState(0);
    const [packagekey, setpackagekey] = useState(1);
    const [vibeshow, setvibeshow] = useState(0);
    const [couponshow, setcouponshow] = useState(0);
    const [noteshow, setnoteshow] = useState(0);
    const [redeemshow, setredeemshow] = useState(0);
    const [redeemShow, setredeemShow] = useState(false);
    let [discountPercentage, setdiscountPercentage] = useState(0)
    let [count, setCount] = useState(0);
    const [Checkedbox, setCheckbox] = useState(false);
    let Shippingcountry = ''
    let Billingcity = ''
    let Billingstate = ''
    let BillingCountry = ''
    let Shippingstate = ''
    let Shippingcity = ''
    let OrginalPrice = 0
    let discountNotesPrice = 0
    let discountPendrivePrice = 0
    // let discountPercentage = 0
    let NotescouponPrice = 0
    let PendrivecouponPrice = 0
    let redeem = 0
    let isShip = false;
    let isBilling = false;
    const showToast = (message) => {
        toast.success(message);
    };
    const showToastError = (message) => {
        toast.error(message);
    };
    const selectShipCountry = async (slctCountry) => {
        profileDetails({
            ...getProfileDetails,
            shippingcountry: slctCountry ? slctCountry.target.value : shipcountryId,
        })
        const data = {
            "country": slctCountry ? slctCountry.target.value : shipcountryId,
            "state": "",
            "city": "",
            "courses": course?.preparingFor
        }
        await getCountryStateCityList(data)
            .then(response => {
                return response.json()
            })
            .then(data => {
                if (data.data.result?.states) {
                    setshipState(data)
                    setshipCity(null)
                    return
                }
                setshipState(null)
                setshipCity(null)
                return
                // setshipState(data)
                // setshipStateId(data.data.result.states[0]._id)
            })
    }
    const selectShipState = async (slctState) => {
        profileDetails({
            ...getProfileDetails,
            shippingstate: slctState ? slctState.target.value : shipstateId,
        })
        const data = {
            "country": "",
            "state": slctState ? slctState.target.value : shipstateId,
            "city": "",
            "courses": course?.preparingFor
        }
        await getCountryStateCityList(data)
            .then(response => {
                return response.json()
            })
            .then(data => {
                if (data.data.result?.city) {
                    setshipCity(data)
                    return
                }
                setshipCity(null)
                return
            })
    }
    const selectShipCity = async (slctCity) => {
        profileDetails({
            ...getProfileDetails,
            shippingcity: slctCity ? slctCity.target.value : shipcityId
        })
        const data = {
            "country": "",
            "state": "",
            "city": slctCity ? slctCity.target.value : shipcityId,
            "courses": course?.preparingFor
        }
        await getCountryStateCityList(data)
            .then(response => {
                return response.json()
            })
            .then(data => {

            })
    }
    const handleInputChange = function (fieldValue, fieldName) {
        profileDetails({ ...getProfileDetails, [fieldName]: fieldValue })
    }
    const getCountry = async () => {
        const data = {
            "country": "",
            "state": "",
            "city": "",
            "courses": course?.preparingFor
        }
        await getCountryStateCityData(data)
            .then(response => {
                return response.json()
            })
            .then(data => {
                setCountry(data)
                setshipCountry(data)
                setState('')
                setCity('')
                setshipCity('')
                setshipState('')

            })
    }
    const choosePackage = (e, i) => {
        index = i
        setIndex(i)
        calculateAddon(shop, i)
    }
    const makeApiCall = () => {
        const data = {
            "orderId": AddonpaymentDetail?.notes?.orderId
        }
        getOrder(data)
            .then(response => {
                return response.json()
            })
            .then(data => {
                if (data.success == true) {
                    if (data.data.transactionStatus == 'COMPLETED') {
                        navigate(`/success/${shop?.title}/${shop?.validity[index]?.validityTitle}`)
                    }
                    else if (data.data.transactionStatus == 'PENDING' || data.data.transactionStatus == 'INITIATED') {
                        var intervalId
                        if (count < 1) {
                            makeApiCall()
                            count = count + 1
                            setCount(count + 1)
                        } else {
                            intervalId = setInterval(makeApiCall, 1000);
                            clearInterval(intervalId); // Stop the interval
                            navigate('/pending')
                        }
                    }
                    else {
                        navigate('/error')
                    }
                }

            }).catch((error) => {
                showToastError("Something went wrong please try agian")
            })
    }
    const selectCountry = async (slctCountry) => {
        profileDetails({
            ...getProfileDetails,
            country: slctCountry ? slctCountry.target.value : countryId
        })
        const data = {
            "country": slctCountry ? slctCountry.target.value : countryId,
            "state": "",
            "city": "",
            "courses": course?.preparingFor
        }
        await getCountryStateCityList(data)
            .then(response => {
                return response.json()
            })
            .then(data => {
                if (data.data.result?.states) {
                    setState(data)
                    setCity(null)
                    return
                }
                setState(null)
                setCity(null)
                return
                // setState(data)
                // setStateId(data.data.result.states[0]._id)
            })
    }
    const selectState = async (slctState) => {
        profileDetails({
            ...getProfileDetails,
            state: slctState ? slctState.target.value : stateId
        })
        const data = {
            "country": "",
            "state": slctState ? slctState.target.value : stateId,
            "city": "",
            "courses": course?.preparingFor
        }
        await getCountryStateCityList(data)
            .then(response => {
                return response.json()
            })
            .then(data => {
                if (data.data.result?.city) {
                    setCity(data)
                    return
                }
                setCity(null)
                return
            })
    }
    const selectCity = async (slctCity) => {
        profileDetails({
            ...getProfileDetails,
            city: slctCity ? slctCity.target.value : cityId
        })
        const data = {
            "country": "",
            "state": "",
            "city": slctCity ? slctCity.target.value : cityId,
            "courses": course?.preparingFor
        }
        await getCountryStateCityList(data)
            .then(response => {
                return response.json()
            })
            .then(data => {

            })
    }
    useEffect(() => {
        countryId && selectCountry()
    }, [countryId])

    useEffect(() => {
        stateId && selectState()
    }, [stateId])

    useEffect(() => {
        cityId && selectCity()
    }, [cityId])
    useEffect(() => {
        shipcountryId && selectShipCountry()
    }, [shipcountryId])
    useEffect(() => {
        shipstateId && selectShipState()
    }, [shipstateId])

    useEffect(() => {
        shipcityId && selectShipCity()
    }, [shipcityId])

    useEffect(() => {
        getCountry()
    }, []);
    const calculateAddon = (data, i) => {
        if (data?.packageType === 3) {
            if (data?.recommendedSubscriptionForAddOn != null) {
                if (data?.recommendedSubscriptionForAddOn?.planPurchased?.isCouponApply === true) {
                    if (discountPercentage != 0) {
                        discountPendrivePrice = data?.recommendedSubscriptionForAddOn?.planPurchased?.vibe?.afterBuyPendriveDiscount != 0 ? data?.recommendedSubscriptionForAddOn?.planPurchased?.vibe?.afterBuyPendriveDiscount : data?.recommendedSubscriptionForAddOn?.planPurchased?.vibe?.afterBuyPendrivePrice
                        PendrivecouponPrice = (discountPendrivePrice * discountPercentage) / 100
                        OrginalPrice = (discountPendrivePrice - PendrivecouponPrice) - redeem
                        setvibeshow(discountPendrivePrice)
                        setcouponshow(PendrivecouponPrice)
                        settotalAmountAddon((OrginalPrice).toFixed(2))
                    }
                    else {
                        OrginalPrice = (data?.recommendedSubscriptionForAddOn?.planPurchased?.vibe?.afterBuyPendriveDiscount != 0 ? data?.recommendedSubscriptionForAddOn?.planPurchased?.vibe?.afterBuyPendriveDiscount : data?.recommendedSubscriptionForAddOn?.planPurchased?.vibe?.afterBuyPendrivePrice) - redeem
                        PendrivecouponPrice = 0
                        discountPercentage = 0
                        setvibeshow(OrginalPrice)
                        setcouponshow(PendrivecouponPrice)
                        settotalAmountAddon((OrginalPrice).toFixed(2))

                    }
                }
                else {
                    OrginalPrice = (data?.recommendedSubscriptionForAddOn?.planPurchased?.vibe?.afterBuyPendriveDiscount != 0 ? data?.recommendedSubscriptionForAddOn?.planPurchased?.vibe?.afterBuyPendriveDiscount : data?.recommendedSubscriptionForAddOn?.planPurchased?.vibe?.afterBuyPendrivePrice) - redeem
                    PendrivecouponPrice = 0
                    discountPercentage = 0
                    setdiscountPercentage(0)
                    setvibeshow(OrginalPrice)
                    setcouponshow(PendrivecouponPrice)
                    settotalAmountAddon((OrginalPrice).toFixed(2))
                }
            }
            else {
                if (data?.validity[i] && data?.validity[i]?.isCouponApply === true) {
                    if (discountPercentage != 0) {
                        discountPendrivePrice = data?.validity[i]?.discountPrice != 0 ? data?.validity[i]?.discountPrice : data?.validity[i]?.mrp
                        PendrivecouponPrice = (discountPendrivePrice * discountPercentage) / 100
                        OrginalPrice = (discountPendrivePrice - PendrivecouponPrice) - redeem
                        setvibeshow(discountPendrivePrice)
                        setcouponshow(PendrivecouponPrice)
                        settotalAmountAddon((OrginalPrice).toFixed(2))
                    }
                    else {
                        OrginalPrice = (data?.validity[i]?.discountPrice != 0 ? data?.validity[i]?.discountPrice : data?.validity[i]?.mrp) - redeem
                        PendrivecouponPrice = 0
                        discountPercentage = 0
                        setvibeshow(OrginalPrice)
                        setcouponshow(PendrivecouponPrice)
                        settotalAmountAddon((OrginalPrice).toFixed(2))

                    }
                }
                else {
                    OrginalPrice = (data?.validity[i]?.discountPrice != 0 ? data?.validity[i]?.discountPrice : data?.validity[i]?.mrp) - redeem
                    PendrivecouponPrice = 0
                    discountPercentage = 0
                    setdiscountPercentage(0)
                    setvibeshow(OrginalPrice)
                    setcouponshow(PendrivecouponPrice)
                    settotalAmountAddon((OrginalPrice).toFixed(2))

                }
            }
        }
        else if (data?.packageType === 2) {
            if (data.recommendedSubscriptionForAddOn != null) {
                if (data?.recommendedSubscriptionForAddOn?.planPurchased?.isCouponApply === true) {
                    if (discountPercentage != 0) {
                        discountNotesPrice = data?.recommendedSubscriptionForAddOn?.planPurchased?.notes?.afterBuyNotesDiscount != 0 ? data?.recommendedSubscriptionForAddOn?.planPurchased?.notes?.afterBuyNotesDiscount : data?.recommendedSubscriptionForAddOn?.planPurchased?.notes?.afterBuyNotesPrice
                        NotescouponPrice = (discountNotesPrice * discountPercentage) / 100
                        OrginalPrice = (discountNotesPrice - NotescouponPrice) - redeem
                        setnoteshow(discountNotesPrice)
                        setcouponshow(NotescouponPrice)
                        settotalAmountAddon((OrginalPrice).toFixed(2))
                    }
                    else {
                        discountNotesPrice = data?.recommendedSubscriptionForAddOn?.planPurchased?.notes?.afterBuyNotesDiscount != 0 ? data?.recommendedSubscriptionForAddOn?.planPurchased?.notes?.afterBuyNotesDiscount : data?.recommendedSubscriptionForAddOn?.planPurchased?.notes?.afterBuyNotesPrice
                        NotescouponPrice = (discountNotesPrice * discountPercentage) / 100
                        OrginalPrice = (discountNotesPrice - NotescouponPrice) - redeem
                        setnoteshow(discountNotesPrice)
                        setcouponshow(NotescouponPrice)
                        settotalAmountAddon((OrginalPrice).toFixed(2))
                    }
                }
                else {
                    OrginalPrice = (data?.recommendedSubscriptionForAddOn?.planPurchased?.notes?.afterBuyNotesDiscount != 0 ? data?.recommendedSubscriptionForAddOn?.planPurchased?.notes?.afterBuyNotesDiscount : data?.recommendedSubscriptionForAddOn?.planPurchased?.notes?.afterBuyNotesPrice) - redeem
                    NotescouponPrice = 0
                    discountPercentage = 0
                    setdiscountPercentage(0)
                    setnoteshow(OrginalPrice)
                    setcouponshow(NotescouponPrice)
                    settotalAmountAddon((OrginalPrice).toFixed(2))
                }
            }
            else {
                if (data?.validity[i] && data?.validity[i]?.isCouponApply === true) {
                    if (discountPercentage != 0) {
                        discountNotesPrice = data?.validity[i]?.discountPrice != 0 ? data?.validity[i]?.discountPrice : data?.validity[i]?.mrp
                        NotescouponPrice = (discountNotesPrice * discountPercentage) / 100
                        OrginalPrice = (discountNotesPrice - NotescouponPrice) - redeem
                        setnoteshow(discountNotesPrice)
                        setcouponshow(NotescouponPrice)
                        settotalAmountAddon((OrginalPrice).toFixed(2))
                    }
                    else {
                        OrginalPrice = (data?.validity[i]?.discountPrice != 0 ? data?.validity[i]?.discountPrice : data?.validity[i]?.mrp) - redeem
                        NotescouponPrice = 0
                        discountPercentage = 0
                        setnoteshow(OrginalPrice)
                        setcouponshow(NotescouponPrice)
                        settotalAmountAddon((OrginalPrice).toFixed(2))
                    }
                }
                else {
                    OrginalPrice = (data?.validity[i]?.discountPrice != 0 ? data?.validity[i]?.discountPrice : data?.validity[i]?.mrp) - redeem
                    NotescouponPrice = 0
                    discountPercentage = 0
                    setdiscountPercentage(0)
                    setnoteshow(OrginalPrice)
                    setcouponshow(NotescouponPrice)
                    settotalAmountAddon((OrginalPrice).toFixed(2))
                }
            }
        }
    }
    const query1 = useQuery(Package_detail_Api, {
        variables: {
            "packageId": id,
            "packageType": type
        },
        fetchPolicy: 'network-only'
    });
    useEffect(() => {
        setShop(query1.data?.listPackagesForApp[0])
        calculateAddon(query1.data?.listPackagesForApp[0], index)
    }, [query1?.data])
    if (query1.loading) return (<><Loader /></>)
    if (query1.error) {
        if (query1.error?.graphQLErrors?.some((e) => e.extensions?.code === 'UNAUTHENTICATED')) {
            //   history.push('/login');
            authorizationCheck(navigate)
        }
        else if (query1.error.graphQLErrors.some((e) => e.extensions?.code === 'INTERNAL_SERVER_ERROR')) {
            return (<>
                <div className="main_wrapper">
                    <div className="col-lg-12">
                        <SomethingWentWrong pathName={location.pathname} />
                    </div>
                </div>
            </>)
        }
        else {
            return (<>
                <div className="main_wrapper">
                    <div className="col-lg-12">
                        <ConnectionError pathName={location.pathname} />
                    </div>
                </div>
            </>)
        }
        console.log(query1.error)
    }
    const onSubmitAddon = async (e) => {
        e.preventDefault();
        if (!course?.collegeName) {
            showToastError('Please update your college details from the profile section')
            return
        }
        if (getProfileDetails?.country == '' || getProfileDetails?.state == '' || getProfileDetails?.city == '' || getProfileDetails?.colonyArea == '' || getProfileDetails?.pincode == '' || getProfileDetails?.flateNumber == '') {
            isBilling = false;
        } else {
            isBilling = true;
        }
        if (getProfileDetails?.shippingcountry == '' || getProfileDetails?.shippingstate == '' || getProfileDetails?.shippingcity == '' || getProfileDetails?.shippingcolonyArea == '' || getProfileDetails?.shippingpincode == '' || getProfileDetails?.shippingflateNumber == '') {
            isShip = false;
        } else {
            isShip = true;
            // this.notificationService.show('Please fill all mandatory fields in Shipping Address')
        }
        if (isBilling == true && isShip == true) {
            if (getProfileDetails.country != '') {
                country?.data?.result?.countries?.map((obj) => {
                    if (obj._id == getProfileDetails.country) {
                        BillingCountry = (obj.title)
                    }
                })
            }
            if (getProfileDetails.state != '') {
                state?.data?.result?.states?.map((obj) => {
                    if (obj._id == getProfileDetails.state) {
                        Billingstate = (obj.title)
                    }
                })
            }
            if (getProfileDetails.city != '') {
                city?.data?.result?.city?.map((obj) => {
                    if (obj._id == getProfileDetails.city) {
                        Billingcity = (obj.title)
                    }
                })
            }
            if (getProfileDetails.shippingcountry != '') {
                shipcountry?.data?.result?.countries.map((obj) => {
                    if (obj._id == getProfileDetails.shippingcountry) {
                        Shippingcountry = (obj.title)
                    }
                })

            }
            if (getProfileDetails.shippingstate != '') {
                shipstate?.data?.result?.states?.map((obj) => {
                    if (obj._id == getProfileDetails.shippingstate) {
                        Shippingstate = (obj.title)
                    }
                })
            }
            if (getProfileDetails.shippingcity != '') {
                shipcity?.data?.result?.city?.map((obj) => {
                    if (obj._id == getProfileDetails.shippingcity) {
                        Shippingcity = (obj.title)
                    }
                })
            }
            const data = {
                "couponName": coupon,
                "currency": "INR",
                "packageId": shop?._id,
                "packageType": shop?.packageType,
                "purchaseType": "SHOP",
                "validityId": shop?.validity[index]?._id,
                "billingAddress": {
                    "colonyArea": getProfileDetails?.colonyArea,
                    "city": Billingcity != undefined ? Billingcity : '',
                    "country": BillingCountry != undefined ? BillingCountry : '',
                    "flatNumber": getProfileDetails?.flateNumber,
                    "landmark": getProfileDetails?.landmark,
                    "pincode": getProfileDetails?.pincode,
                    "state": Billingstate != undefined ? Billingstate : '',
                    "fullAddress": getProfileDetails?.flateNumber + "," + getProfileDetails?.colonyArea + "," + getProfileDetails?.landmark + "," + Billingcity + "," + Billingstate + "," + getProfileDetails?.pincode,
                },
                "shippingAddress": {
                    "colonyArea": getProfileDetails?.shippingcolonyArea,
                    "city": Shippingcity != undefined ? Shippingcity : '',
                    "country": Shippingcountry != undefined ? Shippingcountry : '',
                    "flatNumber": getProfileDetails?.shippingflateNumber,
                    "landmark": getProfileDetails?.shippinglandmark,
                    "pincode": getProfileDetails?.shippingpincode,
                    "state": Shippingstate != undefined ? Shippingstate : '',
                    "fullAddress": getProfileDetails?.shippingflateNumber + "," + getProfileDetails?.shippingcolonyArea + "," + getProfileDetails?.shippinglandmark + "," + Shippingcity + "," + Shippingstate + "," + getProfileDetails?.shippingpincode,
                },
            }
            await CreateOrder(data)
                .then(response => {
                    return response.json()
                })
                .then((data) => {
                    // let req = JSON.parse(decrypt(data))
                    if (data.success == true) {
                        AddonpaymentDetail = data?.data
                        setAddonpaymentDetail(data.data)
                        AddonrazorpayOpen(e)
                    }
                    else if (data.success == false) {
                        showToastError(data.message)
                    }
                }).catch((err) => {
                    showToastError("Something went wrong please try agian")
                })
        }
        else {
            showToastError("Please enter billing and shipping address")
        }
    }
    const AddonrazorpayOpen = async () => {
        var options = {
            "key": process.env.REACT_APP_Razorpay_Key, // Enter the Key ID generated from the Dashboard
            "amount": totalAmountAddon * 100, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
            "currency": "INR",
            "name": "eGurukul",
            "description": course.name,
            "image": "https://rzp-mobile.s3.amazonaws.com/images/rzp.png",
            "order_id": AddonpaymentDetail?.id, //This is a sample Order ID. Pass the `id` obtained in the response of Step 1
            "capture": "0",
            "method": "all",
            "handler": (response) => {
                makeApiCall()
            },
            "prefill": {
                "name": course?.name,
                "email": course?.email,
                "contact": course?.mobileNo,
                "method": "All",
                "_[flow]": "intent",
                "upi_app_package_name": "com.phonepe.app",
                "prefill": "preFill"
            },
            // "notes": {
            //     "appOrderId": "WEB_" + AddonpaymentDetail?.notes?.orderId,
            //     "mobileNo": course?.mobileNo,
            //     "invoiceId": AddonpaymentDetail?.notes?.invoiceNumber,
            //     "notesAddOn": shop?.validity[index]?.withNotes != false ? shop?.validity[index]?.notes?.title + ',' + discountNotesPrice + ',' + shop?.validity[index]?.notes?.notePackageCode : '',
            //     "packageDetails": shop?.packageType != 2 ? "Pendrive" : "Notes" + shop?.title + ',' + shop?.packageCode,
            //     "month": shop?.validity[index]?.months,
            //     "billingAddress": getProfileDetails?.flateNumber + "," + getProfileDetails?.colonyArea + "," + getProfileDetails?.landmark + "," + Billingcity + "," + Billingstate + "," + getProfileDetails?.pincode,
            //     "couponName": coupon != null ? coupon : '',
            //     "college": course?.country + "," + course?.collegeState + ',' + course?.collegeCity + ',' + course?.collegeName,
            //     "shippingAddress": getProfileDetails?.shippingflateNumber + ',' + getProfileDetails?.shippingcolonyArea + ',' + getProfileDetails?.shippinglandmark + ',' + Shippingcity + ',' + Shippingstate + ',' + getProfileDetails?.shippingpincode,
            // },
            "theme": {
                "color": "#3AC3FF",
                "hide_topbar": "true",
                "theme": "theme"
            }
        }
        const res = await loadScript(
            "https://checkout.razorpay.com/v1/checkout.js"
        );

        let razorpay = new window.Razorpay(options);
        razorpay.open();
        razorpay.on('payment.failed', (response) => {
            makeApiCall()
        });
    }

    const checkBoxMark = (e) => {
        if (e.target.checked) {
            setshipState(state)
            setshipCity(city)
            profileDetails({
                ...getProfileDetails,
                shippinglandmark: getProfileDetails.landmark,
                shippingpincode: getProfileDetails.pincode,
                shippingflateNumber: getProfileDetails.flateNumber,
                shippingcolonyArea: getProfileDetails.colonyArea,
                shippingcity: getProfileDetails.city,
                shippingcountry: getProfileDetails.country,
                shippingstate: getProfileDetails.state
            })
            setCheckbox(true)
        }
        else {
            setshipState(null)
            setshipCity(null)
            profileDetails({
                ...getProfileDetails,
                shippinglandmark: '',
                shippingpincode: '',
                shippingflateNumber: '',
                shippingcolonyArea: '',
                shippingcity: '',
                shippingcountry: '',
                shippingstate: '',
            })
            setCheckbox(false)
        }
    }


    const RemoveCoupon = () => {
        if (coupon == '') {
            setpackagekey(2)
            setCoupon('')
            discountPercentage = 0
            setdiscountPercentage(0)
            calculateAddon(shop, index)
        }
        setCoupon('')
        setpackagekey(1)
        discountPercentage = 0
        setdiscountPercentage(0)
        calculateAddon(shop, index)
        showToastError('Coupon Removed Successful')
    }

    const couponEnter = (e) => {
        setCoupon((e.target.value).trimStart())
    }

    const addCoupon = async () => {
        setpackagekey(1)
        if (coupon == '' || coupon == undefined || coupon == null) {
            discountPercentage = 0
            setdiscountPercentage(0)
            calculateAddon(shop, index)
            setpackagekey(1)
            showToastError('Please Apply Any Coupon')
            return
        }
        const data = {
            couponCode: coupon,
            shopPackageId: shop?._id,
            validityId: shop?.validity[index]?._id,
        }
        await shopcoupon(data)
            .then(response => {
                return response.json()
            })
            .then(data => {
                let req = JSON.parse(decrypt(data))
                if (req.data.code == 1) {
                    discountPercentage = req.data.result.discountPercentage
                    setdiscountPercentage(req.data.result.discountPercentage)
                    calculateAddon(shop, index)
                    showToast(req.data.message)
                    setpackagekey(2)
                }
                else {
                    showToastError(req.data.message)
                }
            })
    }

    return (
        <>
            <div className="main_wrapper">
                <div className="breadcrumbs">
                    <ul className="breadcrumb">
                        <li className="breadcrumb-item"><a >Home</a></li>
                        <li className="breadcrumb-item active"><a >Shop</a></li>
                    </ul>
                </div>
                <section className="videoLayer_wrapper subscription_plans_wrapper section_side_padding">
                    <ToastContainer autoClose={500} limit={1} />
                    <div className='row'>
                        <div className="col-lg-8 col-md-7 col-sm-12">
                            <div className="recommended_video_wrapper">
                                <div className="choose_plans_wrapper d-flex align-items-center">
                                    <figure className="arrow" >
                                        <Link to={'/package'}>
                                            <img src={Icons.BackArrow} alt="" className="img-fluid" />
                                        </Link>
                                    </figure>
                                    <div className="subscription_ttl">
                                        <h5>Shop Purchase</h5>
                                    </div>
                                </div>
                            </div>
                            <div className="recommended_video_wrapper">
                                <div className="plans_details_wrapper">
                                    <div className="plans_main_ttl">
                                        <h5>Details</h5>
                                    </div>
                                    <ul type="none" shopppppppp className="">
                                        {
                                            shop?.newDescription?.length > 0 ? shop?.newDescription && shop?.newDescription.map(obj => (
                                                <li>{obj}</li>
                                            )) : <li dangerouslySetInnerHTML={{ __html: shop?.description }}></li>
                                        }
                                    </ul>
                                </div>
                            </div>
                            <div className="recommended_video_wrapper">
                                <div className="plans_details_wrapper">
                                    <div className="plans_main_ttl">
                                        <h5>Choose Package</h5>
                                    </div>
                                    <div className="plans_packages d-flex flex-wrap">
                                        {
                                            shop?.recommendedSubscriptionForAddOn === null &&
                                            shop?.validity && shop?.validity.map((data, i) => (
                                                <label for={`packageSelected${i}`} onClick={(e) => choosePackage(e, i)}>
                                                    <input type="radio" id={`packageSelected${i}`} name="radioName" hidden />
                                                    <div className={`plans_info ${(packages == true && index == i) ? 'selected' : ''}`}>
                                                        {
                                                            data.validityTitle !== '' &&
                                                            <span>{data?.validityTitle}</span>
                                                        }
                                                        <h6>&#8377; {data?.discountPrice ? data?.discountPrice : data?.mrp}</h6>
                                                        {
                                                            data?.discountPrice != 0 &&
                                                            <del>&#8377; {data?.mrp}</del>
                                                        }
                                                    </div>
                                                </label>
                                            ))
                                        }
                                        {
                                            shop?.recommendedSubscriptionForAddOn !== null &&
                                            <label for={`packageSelected`}>
                                                <input type="radio" id={`packageSelected`} name="radioName" hidden />
                                                {shop?.packageType === 3 &&
                                                    <div className={`plans_info ${(packages == true) ? 'selected' : ''}`}>
                                                        {
                                                            shop?.recommendedSubscriptionForAddOn?.planPurchased?.validityTitle !== '' &&
                                                            <span>{shop?.recommendedSubscriptionForAddOn?.planPurchased?.validityTitle}</span>
                                                        }
                                                        <h6>{shop?.recommendedSubscriptionForAddOn?.planPurchased?.vibe?.afterBuyPendriveDiscount ? shop?.recommendedSubscriptionForAddOn?.planPurchased?.vibe?.afterBuyPendriveDiscount : shop?.recommendedSubscriptionForAddOn?.planPurchased?.vibe?.afterBuyPendrivePrice}</h6>
                                                        {
                                                            shop?.recommendedSubscriptionForAddOn?.planPurchased?.vibe?.afterBuyPendriveDiscount != 0 &&
                                                            <del>{shop?.recommendedSubscriptionForAddOn?.planPurchased?.vibe?.afterBuyPendrivePrice}</del>
                                                        }
                                                    </div>
                                                }
                                                {shop?.packageType === 2 &&
                                                    <div className={`plans_info ${(packages == true) ? 'selected' : ''}`}>
                                                        {
                                                            shop?.recommendedSubscriptionForAddOn?.planPurchased?.validityTitle !== '' &&
                                                            <span>{shop?.recommendedSubscriptionForAddOn?.planPurchased?.validityTitle}</span>
                                                        }
                                                        <h6>{shop?.recommendedSubscriptionForAddOn?.planPurchased?.notes?.afterBuyNotesDiscount ? shop?.recommendedSubscriptionForAddOn?.planPurchased?.notes?.afterBuyNotesDiscount : shop?.recommendedSubscriptionForAddOn?.planPurchased?.notes?.afterBuyNotesPrice}</h6>
                                                        {
                                                            shop?.recommendedSubscriptionForAddOn?.planPurchased?.notes?.afterBuyNotesDiscount != 0 &&
                                                            <del>{shop?.recommendedSubscriptionForAddOn?.planPurchased?.notes?.afterBuyNotesPrice}</del>
                                                        }
                                                    </div>
                                                }
                                            </label>
                                        }
                                    </div>
                                </div>
                            </div>

                            <div className="recommended_video_wrapper">
                                <div className="plans_details_wrapper">
                                    <div className="plans_main_ttl">
                                        <h5>Enter Coupon Code</h5>
                                    </div>
                                    <div className="coupon_code">
                                        <div className="coupon_input d-flex align-item-center">
                                            <div className="code">
                                                {
                                                    packagekey == 1 &&
                                                    <input type="text" className="form-control" placeholder="Write Here" value={coupon} onChange={(e) => couponEnter(e)} />
                                                }
                                                {
                                                    packagekey == 2 &&
                                                    <input type="text" className="form-control" placeholder="Write Here" value={coupon} disabled={true} onChange={(e) => couponEnter(e)} />
                                                }
                                            </div>
                                            <div className="apply_btn">
                                                {packagekey == 1 &&
                                                    <button type="button" className="btn btn_apply" onClick={addCoupon}>Apply <img src={Icons.ArrowBlue} alt="" className="img-fluid" /></button>
                                                }
                                                {
                                                    packagekey == 2 &&
                                                    <button type="button" className="btn btn_apply" onClick={RemoveCoupon}>Reset <img src={Icons.ArrowBlue} alt="" className="img-fluid" /></button>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="form_submission">
                                <form onSubmit={(e) => { onSubmitAddon(e) }}>
                                    <div className="recommended_video_wrapper">
                                        <div className="plans_details_wrapper">
                                            <div className="plans_main_ttl">
                                                <h5>Billing Address</h5>
                                            </div>
                                            <div className="billing_address">
                                                {/* <form action="" method=""> */}
                                                <div className="row">
                                                    <div className="col-lg-6 col-md-6 col-sm-12">
                                                        <div className="form-group">
                                                            <input type="text" className="form-control" id="" placeholder="Flat, House No., Building, Apartment*" onChange={(e) => handleInputChange((e.target.value).trimStart(), 'flateNumber')} value={getProfileDetails.flateNumber} />
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6 col-md-6 col-sm-12">
                                                        <div className="form-group">
                                                            <input type="text" className="form-control" id="" placeholder="Area, Colony, Street, Sector, Village*" onChange={(e) => handleInputChange((e.target.value).trimStart(), 'colonyArea')} value={getProfileDetails.colonyArea} />
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-3 col-md-6 col-sm-12">
                                                        <div className="form-group">
                                                            <input type="text" className="form-control" id="" placeholder="Landmark" onChange={(e) => handleInputChange((e.target.value).trimStart(), 'landmark')} value={getProfileDetails.landmark} />
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-3 col-md-6 col-sm-12">
                                                        <div className="form-group">
                                                            <input type="tel" className="form-control" id="" maxlength="6" placeholder="Pincode*" onChange={(e) => handleInputChange(((e.target.value).trimStart()).replace(/\D/g, ''), 'pincode')} value={getProfileDetails.pincode} />
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6 col-md-6 col-sm-12">
                                                        <div className="form-group">
                                                            <select name="" id="" className="form-control" onChange={(event) => selectCountry(event)}>
                                                                <option value="" selected disabled>Select Country</option>
                                                                {
                                                                    country && country.data.result.countries.map((d, i) => (
                                                                        <option value={d._id} selected={getProfileDetails.country && getProfileDetails.country === d._id}>{d.title}</option>
                                                                    ))
                                                                }
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-3 col-md-6 col-sm-12">
                                                        <div className="form-group">
                                                            <select name="" id="" className="form-control" onChange={(event) => selectState(event)}>
                                                                <option value="" selected disabled>Select State</option>
                                                                {
                                                                    (state != null && state.data) && state.data.result.states.map((d, i) => (
                                                                        <option value={d._id} selected={getProfileDetails.state && getProfileDetails.state === d._id}>{d.title}</option>
                                                                    ))
                                                                }
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-3 col-md-6 col-sm-12">
                                                        <div className="form-group">
                                                            <select name="" id="" className="form-control" onChange={(event) => selectCity(event)}>
                                                                <option value="" selected disabled>Select City</option>
                                                                {
                                                                    (city && city.data) && city.data.result.city.map((d, i) => (
                                                                        <option value={d._id} selected={getProfileDetails.city && getProfileDetails.city === d._id}>{d.title}</option>
                                                                    ))
                                                                }
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* </form> */}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="recommended_video_wrapper">
                                        <div className="plans_details_wrapper">
                                            <div className="plans_main_ttl shipping_address">
                                                <h5>Shipping Address</h5>
                                                <div className="custom-control custom-checkbox">
                                                    <input type="checkbox" className="custom-control-input" id="select_ship" name="example1" checked={Checkedbox} onChange={(e) => checkBoxMark(e)} />
                                                    <label className="custom-control-label" for="select_ship">My Shipping address is same as my Billing address</label>
                                                </div>
                                            </div>
                                            {
                                                Checkedbox === false &&
                                                <div className="billing_address">
                                                    {/* <form action="" method=""> */}
                                                    <div className="row">
                                                        <div className="col-lg-6 col-md-6 col-sm-12">
                                                            <div className="form-group">
                                                                <input type="text" className="form-control" id="" placeholder="Flat, House No., Building, Apartment*" onChange={(e) => handleInputChange((e.target.value).trimStart(), 'shippingflateNumber')} value={getProfileDetails.shippingflateNumber} />
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-6 col-md-6 col-sm-12">
                                                            <div className="form-group">
                                                                <input type="text" className="form-control" id="" placeholder="Area, Colony, Street, Sector, Village*" onChange={(e) => handleInputChange((e.target.value).trimStart(), 'shippingcolonyArea')} value={getProfileDetails.shippingcolonyArea} />
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-3 col-md-6 col-sm-12">
                                                            <div className="form-group">
                                                                <input type="text" className="form-control" id="" placeholder="Landmark" onChange={(e) => handleInputChange((e.target.value).trimStart(), 'shippinglandmark')} value={getProfileDetails.shippinglandmark} />
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-3 col-md-6 col-sm-12">
                                                            <div className="form-group">
                                                                <input type="text" className="form-control" maxlength="6" id="" placeholder="Pincode*" onChange={(e) => handleInputChange(((e.target.value).trimStart()).replace(/\D/g, ''), 'shippingpincode')} value={getProfileDetails.shippingpincode} />
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-6 col-md-6 col-sm-12">
                                                            <div className="form-group">
                                                                <select name="" id="" className="form-control" onChange={(event) => selectShipCountry(event)}>
                                                                    <option value="" selected >Select Country</option>
                                                                    {
                                                                        shipcountry && shipcountry.data.result.countries.map((d, i) => (
                                                                            <option value={d._id} selected={getProfileDetails.shippingcountry && getProfileDetails.shippingcountry === d._id} >{d.title}</option>
                                                                        ))
                                                                    }
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-3 col-md-6 col-sm-12">
                                                            <div className="form-group">
                                                                <select name="" id="" className="form-control" onChange={(event) => selectShipState(event)}>
                                                                    <option value="" selected >Select State</option>
                                                                    {
                                                                        (shipstate != null && shipstate.data) && shipstate.data.result.states.map((d, i) => (
                                                                            <option value={d._id} selected={getProfileDetails.shippingstate && getProfileDetails.shippingstate === d._id}>{d.title}</option>
                                                                        ))
                                                                    }
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-3 col-md-6 col-sm-12">
                                                            <div className="form-group">
                                                                <select name="" id="" className="form-control" onChange={(event) => selectShipCity(event)}>
                                                                    <option value="" selected >Select City</option>
                                                                    {
                                                                        (shipcity && shipcity.data) && shipcity.data.result.city.map((d, i) => (
                                                                            <option value={d._id} selected={getProfileDetails.shippingcity && getProfileDetails.shippingcity === d._id}>{d.title}</option>
                                                                        ))
                                                                    }
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {/* </form> */}
                                                </div>
                                            }
                                        </div>
                                    </div>

                                    <div className="recommended_video_wrapper ">
                                        <div className="plan_price d-flex align-items-center justify-content-between">
                                            <h3>₹ {totalAmountAddon} <span onClick={orderInfo}>View Details <img src={Icons.OrderDetailInfo} alt="" className="img-fluid" /></span></h3>
                                            <button type="submit" className="btn btn_buy">Buy Now</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-12">
                            {/* <div className="videos_wrapper">
                            <div className="buy_packages d-flex align-items-center">
                            <div className="package_text">
                            <h6>Buy Package</h6>
                                    <p>Buy Package to unlock content and Start Learning</p>
                                </div>
                                <div className="package_img">
                                <img src={Images.Package} alt="" className="img-fluid"/>
                                </div>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </section>
            </div>
            <Modal
                show={orderShow}
                onHide={orderHide}
                backdrop="static"
                className="detail_modal order_summary"
                centered
            >
                <Modal.Header>
                    <Modal.Title>
                        <h4>Order Summary <span>({shop?.title})</span></h4>
                        <span className="cross_icon">
                            <img src={Icons.ModalCross} alt="" className="img-fluid" onClick={orderHide} />
                        </span>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="account_option_wrapper">
                        <div className="main_accrodion">
                            <div id="accordion">
                                {
                                    shop?.packageType == 3 && shop?.recommendedSubscriptionForAddOn !== null &&
                                    <div className="vibe_dropdown_wrapper">
                                        <div className="vibe_header">
                                            <a className="card-link" data-toggle="collapse" href="#collapseOne">
                                                <div className="vibe_plans_hedr d-flex align-items-center justify-content-between">
                                                    <div className="vibe_ttl">
                                                        <h6>Vibe Package</h6>
                                                    </div>
                                                    <div className="vibe_price">
                                                        <span>₹{vibeshow}</span>
                                                    </div>
                                                </div>
                                                <span className="down_arrow">
                                                    <img src={Icons.OrderDropdown} alt="Dropdown" className="img-fluid" />
                                                </span>
                                            </a>
                                        </div>
                                        <div id="collapseOne" className="collapse show" data-parent="#accordion">
                                            <div className="price_body">
                                                <ul type="none">
                                                    <li className="d-flex align-items-center justify-content-between">
                                                        <div className="vibe_amount">
                                                            <h6>Original Amount</h6>
                                                        </div>
                                                        <div className="vibe_price">
                                                            <span>₹{shop?.recommendedSubscriptionForAddOn?.planPurchased?.vibe?.afterBuyPendrivePrice}</span>
                                                        </div>
                                                    </li>
                                                    <li className="d-flex align-items-center justify-content-between">
                                                        <div className="vibe_amount">
                                                            <h6>Discounted Amount</h6>
                                                        </div>
                                                        <div className="vibe_price">
                                                            <span className="green">-₹{shop?.recommendedSubscriptionForAddOn?.planPurchased?.vibe?.afterBuyPendriveDiscount !== 0 ? shop?.recommendedSubscriptionForAddOn?.planPurchased?.vibe?.afterBuyPendrivePrice - shop?.recommendedSubscriptionForAddOn?.planPurchased?.vibe?.afterBuyPendriveDiscount : 0}</span>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                }
                                {
                                    shop?.recommendedSubscriptionForAddOn === null &&
                                    <div className="vibe_dropdown_wrapper">
                                        <div className="vibe_header">
                                            <a className="card-link" data-toggle="collapse" href="#collapseOne">
                                                <div className="vibe_plans_hedr d-flex align-items-center justify-content-between">
                                                    {
                                                        shop?.packageType == 3 &&
                                                        <div className="vibe_ttl">
                                                            <h6>Vibe Package</h6>
                                                        </div>
                                                    }
                                                    {
                                                        shop?.packageType == 2 &&
                                                        <div className="vibe_ttl">
                                                            <h6>Note Package</h6>
                                                        </div>
                                                    }
                                                    <div className="vibe_price">
                                                        <span>₹{noteshow + vibeshow}</span>
                                                    </div>
                                                </div>
                                                <span className="down_arrow">
                                                    <img src={Icons.OrderDropdown} alt="Dropdown" className="img-fluid" />
                                                </span>
                                            </a>
                                        </div>
                                        <div id="collapseOne" className="collapse show" data-parent="#accordion">
                                            <div className="price_body">
                                                <ul type="none">
                                                    <li className="d-flex align-items-center justify-content-between">
                                                        <div className="vibe_amount">
                                                            <h6>Original Amount</h6>
                                                        </div>
                                                        <div className="vibe_price">
                                                            <span>₹{shop?.validity[index]?.mrp}</span>
                                                        </div>
                                                    </li>
                                                    <li className="d-flex align-items-center justify-content-between">
                                                        <div className="vibe_amount">
                                                            <h6>Discounted Amount</h6>
                                                        </div>
                                                        <div className="vibe_price">
                                                            <span className="green">-₹{shop?.validity[index]?.discountPrice !== 0 ? shop?.validity[index]?.mrp - shop?.validity[index]?.discountPrice : 0}</span>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                }
                                {
                                    shop?.packageType == 2 && shop?.recommendedSubscriptionForAddOn === true &&
                                    <div className="vibe_dropdown_wrapper">
                                        <div className="vibe_header">
                                            <a className="card-link" data-toggle="collapse" href="#collapseTwo">
                                                <div className="vibe_plans_hedr d-flex align-items-center justify-content-between">
                                                    <div className="vibe_ttl">
                                                        <h6>Notes Amount</h6>
                                                    </div>
                                                    <div className="vibe_price">
                                                        <span>₹{noteshow}</span>
                                                    </div>
                                                </div>
                                                <span className="down_arrow">
                                                    <img src={Icons.OrderDropdown} alt="Dropdown" className="img-fluid" />
                                                </span>
                                            </a>
                                        </div>
                                        <div id="collapseTwo" className="collapse" data-parent="#accordion">
                                            <div className="price_body">
                                                <ul type="none">
                                                    <li className="d-flex align-items-center justify-content-between">
                                                        <div className="vibe_amount">
                                                            <h6>Original Amount</h6>
                                                        </div>
                                                        <div className="vibe_price">
                                                            <span>₹{shop?.recommendedSubscriptionForAddOn?.planPurchased?.notes?.afterBuyNotesPrice}</span>
                                                        </div>
                                                    </li>
                                                    <li className="d-flex align-items-center justify-content-between">
                                                        <div className="vibe_amount">
                                                            <h6>Discounted Amount</h6>
                                                        </div>
                                                        <div className="vibe_price">
                                                            <span className="green">-₹{shop?.recommendedSubscriptionForAddOn?.planPurchased?.notes?.afterBuyNotesDiscount !== 0 ? shop?.recommendedSubscriptionForAddOn?.planPurchased?.notes?.afterBuyNotesPrice - shop?.recommendedSubscriptionForAddOn?.planPurchased?.notes?.afterBuyNotesDiscount : 0}</span>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                        <div className="final_price">
                            <ul type="none">
                                <li className="d-flex align-items-center justify-content-between">
                                    <div className="vibe_amount">
                                        <h6>Coupon Discount</h6>
                                    </div>
                                    <div className="vibe_price">
                                        <span>₹ {couponshow}</span>
                                    </div>
                                </li>
                                {/* <li className="d-flex align-items-center justify-content-between">
                                    <div className="vibe_amount">
                                        <h6>Coin Discount</h6>
                                    </div>
                                    <div className="vibe_price">
                                        <span>₹ {redeemshow}</span>
                                    </div>
                                </li> */}
                                <li className="d-flex align-items-center justify-content-between">
                                    <div className="vibe_amount">
                                        <h6 className="green">Total Amount</h6>
                                    </div>
                                    <div className="vibe_price">
                                        <span className="green">₹ {totalAmountAddon}</span>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
        // <Modal
        //     show={courseShowData}
        //     onHide={courseHide}
        //     backdrop="static"
        //     className="detail_modal order_summary"
        //     centered>
        //     <Modal.Header>
        //         <Modal.Title>
        //             <div>Course Change</div>
        //         </Modal.Title>
        //     </Modal.Header>
        //     <Modal.Body>
        //         <div class="course_change_content text-center">
        //             <div class="book_img">
        //                 {/* <img src="assets/images/device_img.png" alt="" class="img-fluid cancel_cross"> */}
        //             </div>
        //             <h4>Not a {dataset?.course} student</h4>
        //             <p>You are a student of {course?.preparingFor}  course. In order to purchase package of this course, you need to change your current course. Click Yes to change your course.</p>
        //             <div class="confirmation_course">
        //                 <button type="button" class="btn btn_confirm_change yes_outline_btn" onClick={updatecourse}>Yes</button>
        //                 <button type="button" class="btn btn_confirm_change"onClick={home} >No</button>
        //             </div>
        //         </div>
        //     </Modal.Body>
        // </Modal>
    )
}